export default __webpack_public_path__ + "static/media/result.f812a08b.svg";